import { render, staticRenderFns } from "./PayrollUser.vue?vue&type=template&id=b4ae13a4&scoped=true"
import script from "./PayrollUser.vue?vue&type=script&lang=js"
export * from "./PayrollUser.vue?vue&type=script&lang=js"
import style0 from "./PayrollUser.vue?vue&type=style&index=0&id=b4ae13a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ae13a4",
  null
  
)

export default component.exports